/*
 * PortUNA Framework (http://www.portuna.de/)
 *
 * @author     Grandke, Luke <grandke@portuna.de>
 * @copyright  PortUNA Neue Medien GmbH (http://www.portuna.de)
 * @created    18.9.2024 11:44 Uhr
 */

import {parseReferrer, ROUTE_REF_PREFIX, ROUTE_REF_REGEX} from '@/utils/portuna';
import {type RouteLocationRaw, useRouter} from 'vue-router';

export function useRouterUtils()
{
    const router = useRouter();

    const routerGoBack = (fallbackRoute: RouteLocationRaw = '/', followRef = true) =>
    {
        let ref = followRef && getCurrentRefParam();

        if (ref)
        {
            router.push(ref).catch(console.error);
        }
        // actually "=== 1" but vue seems to have a default push, thus 2
        else if (window.history.length <= 2)
        {
            router.push(fallbackRoute).catch(console.error);
        }
        else
        {
            router.go(-1);
        }
    };

    const getCurrentRefParam = () =>
    {
        if (router.currentRoute?.value?.params?.ref)
        {
            return parseReferrer(router.currentRoute?.value?.params?.ref);
        }

        return '';
    };

    const resolveRef = () =>
    {
        let ref = getCurrentRefParam();

        return ref ? router.resolve(ref) : null;
    };

    const redirect = (url: RouteLocationRaw | string, replace = true) =>
    {
        const method = replace ? 'replace' : 'push';

        if ('string' === typeof url)
        {
            let match = router.resolve(url);

            if (router.currentRoute.value.fullPath !== match.fullPath)
            {
                router[method]({
                    path: url,
                }).catch(console.error);
            }
        }
        else
        {
            router[method](url).catch(console.error);
        }
    };

    const getReferrer = () =>
    {
        let refRecursionReplace = new RegExp('/' + ROUTE_REF_REGEX);
        return ROUTE_REF_PREFIX + btoa(router.currentRoute.value.fullPath.replace(refRecursionReplace, ''));
    };

    return {
        routerGoBack,
        getCurrentRefParam,
        resolveRef,
        redirect,
        getReferrer
    };
}